import * as React from 'react';
import Layout from '../components/Utilities/Layout';
import { Alert, Box, Chip, Grid, LinearProgress, Stack, Typography } from '@mui/material';
import StorageOutlinedIcon from '@mui/icons-material/StorageOutlined';
import $ from "jquery";
import Common from '../utilities/common';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import QueryBuilderOutlinedIcon from '@mui/icons-material/QueryBuilderOutlined';
import CachedOutlinedIcon from '@mui/icons-material/CachedOutlined';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import PlayCircleOutlineOutlinedIcon from '@mui/icons-material/PlayCircleOutlineOutlined';
import StopCircleOutlinedIcon from '@mui/icons-material/StopCircleOutlined';
import { DataGrid } from '@mui/x-data-grid';
import SecurityTrimmer from '../components/Utilities/SecurityTrimmer';
import { Entity, PermissionLevel } from '../utilities/Permisos';

export interface IDetalleConsolidacionState {
    consolidacionData: any;
    consolidacionLog: any[];
    timer: any;
}

export default class DetalleConsolidacion extends React.Component<{}, IDetalleConsolidacionState> {
    public constructor(props: {}) {
        super(props);

        this.state = {
            consolidacionData: null,
            consolidacionLog: [],
            timer: null
        };
    }

    componentDidMount(): void {
        this.Get();
        this.GetLog();
    }

    public render(): React.ReactElement<{}> {
        return (
            <SecurityTrimmer entity={Entity.Consolidaciones} permission={PermissionLevel.Ver} noAccessMessage='No tiene permisos para ver este contenido.'>
                <Layout breadcrumb={
                    [
                        {
                            title: 'Inicio',
                            url: '/'
                        },
                        {
                            title: 'Consolidaciones',
                            url: '/consolidaciones'
                        },
                        {
                            title: 'Detalle',
                            url: ''
                        }
                    ]
                }>
                    <Box className='stepper'>
                        <Grid container>
                            <Grid item xs={1}>
                                <Typography>
                                    <StorageOutlinedIcon className='mainIcon'/>
                                </Typography>
                            </Grid>
                            <Grid item xs={11}>
                                <Typography className='mainTitle'>
                                Detalle de consolidación
                                </Typography>
                            </Grid>
                        </Grid>
                    </Box>
                    <Box className='main'>
                        <Grid container style={{borderBottom: 'solid 1px #333', marginBottom: '20px'}}>
                            <Grid item xs={6}>
                            {
                                this.state.consolidacionData != null && (
                                    <Typography variant='h6'>
                                        {
                                            new Date(this.state.consolidacionData.date).toLocaleDateString()
                                        }
                                    </Typography>
                                )
                            }
                            </Grid>
                            <Grid item xs={4} style={{textAlign: 'right'}}>
                            {
                                this.state.consolidacionData != null && (
                                    <Stack direction="row" justifyContent={'flex-end'}>
                                        {
                                            this.state.consolidacionData != null && this.state.consolidacionData.status != 'Pendiente' && (
                                                <Stack direction="row" justifyContent={'flex-end'}>
                                                    <PlayCircleOutlineOutlinedIcon/>
                                                    <Typography variant='body2' style={{position: 'relative', top: '5px', marginRight: '10px'}}>
                                                    {
                                                        `${new Date(this.state.consolidacionData.startTime).toLocaleDateString()} ${new Date(this.state.consolidacionData.startTime).toLocaleTimeString()}`
                                                    }
                                                    </Typography>
                                                    {
                                                        (this.state.consolidacionData.status == 'Error' || this.state.consolidacionData.status == 'Finalizado') && (
                                                            <React.Fragment>
                                                                <StopCircleOutlinedIcon/>
                                                                <Typography variant='body2' style={{position: 'relative', top: '5px'}}>
                                                                {
                                                                    `${new Date(this.state.consolidacionData.endTime).toLocaleDateString()} ${new Date(this.state.consolidacionData.endTime).toLocaleTimeString()}`
                                                                }
                                                                </Typography>
                                                            </React.Fragment>
                                                        )
                                                    }
                                                </Stack>
                                            )
                                        }
                                    </Stack>
                                )
                            }
                            </Grid>
                            <Grid item xs={2} style={{textAlign: 'right'}}>
                            {
                                this.state.consolidacionData != null && (
                                    <Chip icon={this.GetIcon()} label={this.state.consolidacionData.status} color={this.GetColor()} style={{position: 'relative', top : '-5px'}}/>
                                )
                            }   
                            </Grid>
                        </Grid>
                        {
                            this.state.consolidacionData != null && this.state.consolidacionData.status == 'Pendiente' && (
                                <Alert severity="info">Esperando que se inicie el proceso de normalización</Alert>
                            )
                        }
                        {
                            this.state.consolidacionData != null && this.state.consolidacionData.status == 'Activo' && (
                                <React.Fragment>
                                    {
                                        this.state.consolidacionLog[0] != null && (
                                            <Typography variant='body2' color="text.secondary" style={{marginTop: '20px'}}>
                                                {
                                                    this.state.consolidacionLog[0].message
                                                }
                                            </Typography>
                                        )
                                    }
                                    {
                                        this.state.consolidacionLog[0] != null && (
                                            <Grid container>
                                                <Grid item xs={12} style={{marginBottom: '20px'}}>
                                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                        <Box sx={{ width: '100%', mr: 1 }}>
                                                            <LinearProgress variant="determinate" value={this.state.consolidacionData.progress} />
                                                        </Box>
                                                        <Box sx={{ minWidth: 35 }}>
                                                            <Typography variant="body2" color="text.secondary">
                                                                {
                                                                    `${this.state.consolidacionData.progress}%`
                                                                }
                                                            </Typography>
                                                        </Box>
                                                    </Box>
                                                </Grid>
                                            </Grid>
                                        )
                                    }
                                </React.Fragment>
                            )
                        }
                        {
                            this.state.consolidacionLog.length > 0 && this.state.consolidacionData != null && (
                                <React.Fragment>
                                    <Typography variant="body2" color="text.secondary" fontWeight={600} style={{marginTop: '20px'}}>
                                        Registro
                                    </Typography>
                                    <DataGrid
                                        rows={this.state.consolidacionLog}
                                        disableColumnFilter
                                        disableColumnSorting
                                        disableColumnMenu
                                        slotProps={{ pagination: { labelRowsPerPage: 'Filas por página' } }}
                                        columns={[
                                            { field: 'date', headerName: 'Fecha', width: 200, renderCell: ({ row }) => (
                                                `${new Date(row.date).toLocaleDateString()} ${new Date(row.date).toLocaleTimeString()}`
                                            ) },
                                            { field: 'message', headerName: 'Mensaje', flex: 1 }
                                        ]}
                                        initialState={{
                                            pagination: {
                                                paginationModel: { page: 0, pageSize: 30 },
                                            },
                                        }}
                                        pageSizeOptions={[30, 60, 100]}
                                        checkboxSelection={false}
                                        hideFooter={this.state.consolidacionLog.length <= 30}
                                    />
                                </React.Fragment>
                            )
                        }
                    </Box>
            </Layout>
            </SecurityTrimmer>
        )
    }

    private Get(): void {
        const id = Common.getUrlParam('n');

        let url = `${Common.END_POINT}/consolidaciones/items/${id}`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            this.setState(
                {
                    consolidacionData: response[0]
                }
            );
        });
    }

    private GetLog(): void {
        const id = Common.getUrlParam('n');

        let url = `${Common.END_POINT}/consolidaciones/items/${id}/log`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            this.setState(
                {
                    consolidacionLog: response
                }
            );
        });
    }

    private GetIcon(): JSX.Element {
        if (this.state.consolidacionData.status == 'Error') {
            return <ErrorOutlineOutlinedIcon />;
        }

        if (this.state.consolidacionData.status == 'Finalizado') {
            return <CheckCircleOutlineOutlinedIcon />;
        }

        if (this.state.consolidacionData.status == 'Pendiente') {
            return <QueryBuilderOutlinedIcon />;
        }

        return <CachedOutlinedIcon />;
    }

    private GetColor(): any {
        if (this.state.consolidacionData.status == 'Error') {
            return 'error';
        }

        if (this.state.consolidacionData.status == 'Finalizado') {
            return 'success';
        }
    }
}